import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button, Divider } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import { AppTheme } from '../../styles/AppTheme';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { adminData } from '../../data/AdminData.js'
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { AppHelper } from '../../helpers/AppHelper';
import { DateRangePicker } from './DateRangePicker';
import { MultiCamPicker } from './MultiCamPicker'
import { EventFilter } from './EventFilter'

export class EventRefreshController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoUpdate: false
    }
  }

  onAutoUpdateChange = (event) => {
    this.setState({ autoUpdate: event.target.checked })
    this.props.eventRefreshHandler(event.target.checked)
  }

  render() {
    return (
      <div
        className={css(CommonStyles.headerMemberAddContainer, Styles.headerMemberAddContainerSecond)} >
        <p className={css(Styles.switchControlLabel)}> Event Refresh | OFF</p>
        <FormControlLabel
          color='secondary'
          className={css(Styles.formControlLabelContainer)}
          control={
            <Switch
              classes={{
                track: this.state.autoUpdate && css(Styles.switchControlLabeltrack),
                checked: css(Styles.switchControlLabelChecked),
                thumb: css(Styles.switchControlLabelThumb),
              }}
              className={css(Styles.formControlSwitch)}
              checked={this.state.autoUpdate}
              onChange={this.onAutoUpdateChange}
            />
          }
        />
        <p className={css(Styles.switchControlLabel)}>ON</p>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventRefreshController.js